const UserAgentService = {
  /**
   * Detects if the client is mobile based on the unreliable User Agent String
   * Uses a Regex from https://gist.github.com/dalethedeveloper/1503252 which should detect even obscure mobile user agents
   * @return {Boolean} true if the current device has a known mobile User Agent String
   */
  isSafari: function () {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  },
  isMobile: function () {
    return /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/.test(
      navigator.userAgent
    );
  },
  isIPad: function () {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document);
  },
  isIE9: function () {
    return document.all && !window.atob;
  },
  matchMobileScreens: function () {
    return window.matchMedia('only screen and (max-width: 768px)');
  },
  isIOS: function () {
    return (
      ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
  },
};

export default UserAgentService;
